import React from 'react';
import { useAuthenticationServiceContext } from '../../../../context/contexts';
import { Error } from './Error';

const NoAccountRegisteredErrorComponent = () => {
  const authService = useAuthenticationServiceContext();
  const { email } = authService.currentUser ?? { email: '' };

  return (
    <Error
      title={{
        key: 'pages:errorBoundary.noAccountRegistered',
        options: { email: email ?? '' },
      }}
    />
  );
};

export default NoAccountRegisteredErrorComponent;
